/**
 * Auto Element Clicked — 클릭 이벤트 자동 캡처
 * interactive 요소 (button, a, [role="button"], input[type="submit"]) 클릭만 추적
 * 같은 요소 500ms 내 중복 무시 (throttle)
 */

import { getElementText } from "./utils";

const INTERACTIVE_SELECTOR = 'button, a, [role="button"], input[type="submit"]';
const THROTTLE_MS = 500;

export function initAutoClick(mixpanel) {
  let lastTarget = null;
  let lastTime = 0;

  function handler(event) {
    try {
      const target = event.target;
      if (!target || typeof target.closest !== "function") return;

      const interactive = target.closest(INTERACTIVE_SELECTOR);
      if (!interactive) return;

      // throttle: 같은 요소 500ms 내 중복 무시
      const now = Date.now();
      if (interactive === lastTarget && now - lastTime < THROTTLE_MS) return;
      lastTarget = interactive;
      lastTime = now;

      // 메인 스레드 블로킹 방지
      const trackFn = function () {
        try {
          mixpanel.track("Auto Element Clicked", {
            element_tag: interactive.tagName.toLowerCase(),
            element_text: getElementText(interactive),
            element_href: interactive.getAttribute("href") || "",
            element_id: interactive.id || "",
            element_classes: interactive.getAttribute("class") || "",
          });
        } catch (e) {
          // 트래킹 실패 시 조용히 무시
        }
      };

      if (typeof requestIdleCallback === "function") {
        requestIdleCallback(trackFn);
      } else {
        setTimeout(trackFn, 0);
      }
    } catch (e) {
      // 핸들러 에러가 서비스로 전파되지 않도록
    }
  }

  document.addEventListener("click", handler, { passive: true, capture: true });
}
